module.exports = __webpack_public_path__ + "img/surfing10classic_icon.3f15cfad.png";